import React, { Component } from 'react';
import './PopoverListToggle.css';

class PopoverListToggle extends Component {
  render() {
    const { label, checked, onToggle } = this.props;
    let classNames = ['PopoverListToggle'];

    return (
      <div className={classNames.join(' ')}>
        <label className="PopoverListToggle__label">{label}</label>
        <label className="PopoverListToggle__switch">
          <input type="checkbox" checked={checked} onChange={onToggle} />
          <div className="PopoverListToggle__slider"></div>
        </label>
      </div>
    );
  }
};

export default PopoverListToggle;



// WEBPACK FOOTER //
// ./src/components/PopoverListToggle.js